import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '__generated__/globalTypes';
import { Vertical } from 'atoms/layout/flex';

import { SportRefereeProgression } from './SportRefereeProgression';
import { RefereeProgression_Referral } from './__generated__/index.graphql';

type Props = {
  referee: RefereeProgression_Referral;
  sport: Sport;
};

export const RefereeProgression = ({ referee, sport }: Props) => {
  return (
    <Vertical gap={2}>
      <SportRefereeProgression
        sport={sport}
        count={referee.refereeSportCardsBoughtFromPrimaryMarketCount}
      />
    </Vertical>
  );
};

RefereeProgression.fragments = {
  referral: gql`
    fragment RefereeProgression_Referral on Referral {
      id
      refereeSportCardsBoughtFromPrimaryMarketCount(sport: $sport)
    }
  ` as TypedDocumentNode<RefereeProgression_Referral>,
};
